// extracted by mini-css-extract-plugin
export default {"select":"product_search__select--LeR0","resultImg":"product_search__resultImg--HI6q","result":"product_search__result--pW8q"};